import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SplitModuleIcon } from 'foundations-assets';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DealSplitIcon = () => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(SplitModuleIcon, {})
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-data-board-card.dealSplitIcon.tooltip"
    })]
  }),
  children: /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInline: "0",
    marginInlineStart: "100",
    children: /*#__PURE__*/_jsx(SplitModuleIcon, {})
  })
});
export default DealSplitIcon;